import { render, staticRenderFns } from "./projectOrder.vue?vue&type=template&id=446d3239&scoped=true"
import script from "./projectOrder.vue?vue&type=script&lang=js"
export * from "./projectOrder.vue?vue&type=script&lang=js"
import style0 from "./projectOrder.vue?vue&type=style&index=0&id=446d3239&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446d3239",
  null
  
)

export default component.exports